import { Controller } from "@hotwired/stimulus"
import feather from 'feather-icons'

export default class extends Controller {
  static values = {
    collapsedHeight: { type: Number, default: 100 },
    linkText: { type: String, default: 'Read more' }
  }

  connect() {
    if (!this.hasContent()) return
    this.expanded = false

    this.setOriginalHeight()
    if (this.originalHeight > this.collapsedHeightValue) {
      this.createToggleLink()
      this.collapse()
      this.createResizeObserver()
    }
  }

  hasContent() {
    return this.element.textContent.trim().length > 0
  }

  disconnect() {
    if (this.resizeObserver) this.resizeObserver.disconnect()
  }

  setOriginalHeight() {
    const prevMaxHeight = this.element.style.maxHeight
    this.element.style.maxHeight = '100%'
    this.originalHeight = this.element.scrollHeight
    this.element.style.maxHeight = prevMaxHeight
  }

  createResizeObserver() {
    this.resizeObserver = new ResizeObserver(() => {
      this.setOriginalHeight()
      if (this.expanded) {
        this.expand()
      }
    })
    this.resizeObserver.observe(this.element)
  }

  createToggleLink() {
    this.toggleLink = document.createElement('div')
    this.toggleLink.innerHTML = this.link(this.linkTextValue, 'down')
    this.toggleLink.addEventListener('click', (e) => {
      e.preventDefault()
      this.toggle()
    })
    this.element.after(this.toggleLink)
    feather.replace()
  }

  toggle() {
    if (this.expanded) {
      this.collapse()
    } else {
      this.expand()
    }
  }

  expand() {
    this.element.style.maxHeight = this.originalHeight + 'px'
    this.toggleLink.innerHTML = this.link(this.linkTextValue, 'up')
    feather.replace()
    this.expanded = true
  }

  collapse() {
    this.element.style.maxHeight = this.collapsedHeightValue + 'px'
    this.toggleLink.innerHTML = this.link(this.linkTextValue, 'down')
    feather.replace()
    this.expanded = false
  }

  link(text, direction) {
    return `
      <a class="small text-decoration-underline mt-2" href="#">
        ${text}
        <i data-feather="chevron-${direction}" width="16"></i>
      </a>
    `
  }
}
